const AdEvents = {
    "AD_ALMOST_FINISHED": "AD_ALMOST_FINISHED",
    "AD_CLICKED": "AD_CLICKED",
    "AD_COMPLETED": "AD_COMPLETED",
    "AD_LOAD_ERROR": "AD_LOAD_ERROR",
    "AD_LOAD_TIMED_OUT": "AD_LOAD_TIMED_OUT",
    "AD_LOADING": "AD_LOADING",
    "AD_LOADED": "AD_LOADED",
    "AD_PAUSED": "AD_PAUSED",
    "AD_PLAY_ERROR": "AD_PLAY_ERROR",
    "AD_PLAYBACK_PROGRESS_UPDATE": "AD_PLAYBACK_PROGRESS_UPDATE",
    "AD_PLAYBACK_TIMED_OUT": "AD_PLAYBACK_TIMED_OUT",
    "AD_REQUESTED": "AD_REQUESTED",
    "AD_RESUMED": "AD_RESUMED",
    "AD_STARTED": "AD_STARTED",
    "ADS_FAILURE": "ADS_FAILURE",
    "ADS_READY": "ADS_READY",
    "ALL_ADS_COMPLETED": "ALL_ADS_COMPLETED",
    "CLIP": "clip",
    "CONTENT_PAUSE_REQUESTED": "CONTENT_PAUSE_REQUESTED",
    "CONTENT_RESUME_REQUESTED": "CONTENT_RESUME_REQUESTED",
    "DURATION_CHANGE": "DURATION_CHANGE",
    "MAX_RETRIES_REACHED": "MAX_RETRIES_REACHED",
    "PAUSED": "PAUSED",
    "REQUEST_AD_PAUSE": "REQUEST_AD_PAUSE",
    "REQUEST_AD_PLAY": "REQUEST_AD_PLAY",
    "RESUMED": "RESUMED",
    "STARTED": "STARTED",
    "SKIPPED": "SKIPPED",
    "SKIP_STATE_CHANGED": "SKIP_STATE_CHANGED",
    "AD_FIRST_QUARTILE": "AD_FIRST_QUARTILE",
    "AD_MIDPOINT": "AD_MIDPOINT",
    "AD_THIRD_QUARTILE": "AD_THIRD_QUARTILE",
    "AD_VOLUME_CHANGE": "AD_VOLUME_CHANGE"
};

export default AdEvents;
